export default "__VITE_ASSET__BDzkx8Sq__"